import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../common/text-input';

function ValidationInput({ error, title, ...props }) {
  return <TextInput error={error === true} errorText={title} {...props} />;
}

ValidationInput.propTypes = {
  error: PropTypes.bool,
  title: PropTypes.string,
};

export default ValidationInput;
